import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../_services/langhfre.service';
import { NavigationService } from 'src/app/_services/navigation.service';

@Component({
  selector: 'app-online-paraphraser',
  templateUrl: './online-paraphraser.component.html',
  styleUrls: ['./online-paraphraser.component.scss']
})
export class OnlineParaphraserComponent implements OnInit {

  constructor(
      private titleService: Title,
      private metaTagService: Meta,
      private LinkService: LinkService,
      public navigationService: NavigationService
    ) { }
    ngOnInit() {
      this.titleService.setTitle('Trinka 文章改寫工具｜AI 智慧改寫句子');
      this.metaTagService.updateTag({ name: 'description', content: "Trinka 的改寫工具可協助你重新表達句子、段落、論文或文章，在不改變原意的前提下，讓內容更清晰易懂。" });
      this.metaTagService.updateTag({ property: 'og:title', content: 'Trinka 文章改寫工具｜AI 智慧改寫句子' });
      this.metaTagService.updateTag({ property: 'og:description', content: 'Trinka 的改寫工具可協助你重新表達句子、段落、論文或文章，在不改變原意的前提下，讓內容更清晰易懂。' });
      this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/features/paraphraser' });
      this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
      this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/paraphraser/online_paraphrase_banner.svg' });
      this.metaTagService.updateTag({ name: 'keywords', content: 'sentence rephraser, paraphraser, online paraphraser, rephrase online, rephrase sentence online,  rewrite the sentence, rewriter tool, rephrase tool, article rewriter tool, sentence changer, paragraph rewriter, rewrite content, sentence reworder, rephrase online free, rewrite sentences online, english rephrase, paragraph changer, sentence rephraser online free' });
      this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
      this.metaTagService.updateTag({ name: 'twitter:title', content: 'Trinka 文章改寫工具｜AI 智慧改寫句子' });
      this.metaTagService.updateTag({ name: 'twitter:description', content: "Trinka 的改寫工具可協助你重新表達句子、段落、論文或文章，在不改變原意的前提下，讓內容更清晰易懂。" });
      this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/paraphraser/online_paraphrase_banner.svg' });
      this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/paraphrasing-tool' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/features/paraphraser' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/features/paraphraser' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/features/paraphraser' });
      // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/features/paraphraser' });
      // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/features/paraphraser' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/features/paraphraser' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/features/paraphraser' });
      
    }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

  stopAllVideos() {
    const iframes = Array.from(document.querySelectorAll('iframe.youtubeVideoForTryDemo'));
    iframes.forEach((iframe) => {
        const htmlIframe = iframe as HTMLIFrameElement;
        htmlIframe.src = htmlIframe.src;
    });
  }

}
